import { render, staticRenderFns } from "./LblCustom.vue?vue&type=template&id=d84fa072&scoped=true"
import script from "./LblCustom.vue?vue&type=script&lang=js"
export * from "./LblCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84fa072",
  null
  
)

export default component.exports